import { render, staticRenderFns } from "./NotificationFooter.vue?vue&type=template&id=71abe2d6&scoped=true&"
import script from "./NotificationFooter.vue?vue&type=script&lang=js&"
export * from "./NotificationFooter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationFooter.vue?vue&type=style&index=0&id=71abe2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71abe2d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VFooter})
